import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import CONTRACT_INPUT_LABEL_PROPS from './contractInputLabelProps';

const PersonLabelInput = ({ input, obj, handleInfoFunc }) => (
  <TextField
    select
    sx={input.sx}
    id={input.id}
    label={input.label}
    value={obj[input.id] || ''}
    onChange={(e) => handleInfoFunc(input.id, e.target.value, obj.id)}
    InputLabelProps={CONTRACT_INPUT_LABEL_PROPS}
  >
    <MenuItem value="SR">Sr.</MenuItem>
    <MenuItem value="SRA">Sra.</MenuItem>
    <MenuItem value="SRTA">Srta.</MenuItem>
  </TextField>
);

PersonLabelInput.propTypes = {
  input: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    sx: PropTypes.shape({
      width: PropTypes.string,
    }),
    inputProps: PropTypes.shape({
      style: PropTypes.shape({
        textTransform: PropTypes.string,
      }),
    }),
  }).isRequired,
  obj: PropTypes.shape({
    id: PropTypes.number,
    rut: PropTypes.string,
    mainDisabled: PropTypes.bool,
  }).isRequired,
  handleInfoFunc: PropTypes.func.isRequired,
};

export default PersonLabelInput;
